import { render, staticRenderFns } from "./ODFLayout.vue?vue&type=template&id=35e4d342"
import script from "./ODFLayout.vue?vue&type=script&lang=js"
export * from "./ODFLayout.vue?vue&type=script&lang=js"
import style0 from "./ODFLayout.vue?vue&type=style&index=0&id=35e4d342&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports